import "setimmediate";
import adapter from "webrtc-adapter";

// Janus expects the WebRTC adapter on the browser global in some builds.
(globalThis as typeof globalThis & { adapter?: typeof adapter }).adapter = adapter;

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { OperationalTabProvider } from './contexts/OperationalTabContext'
import { OperatorLivePresenceProvider } from './contexts/OperatorLivePresenceContext'
import { WebSocketProvider } from './contexts/WebSocketContext'
import { PermissionProvider } from './contexts/PermissionContext'
import { ThemeModeProvider } from './contexts/ThemeModeContext'
import { CallDetailDrawerProvider } from './contexts/CallDetailDrawerContext'
import { TenantProvider } from './contexts/TenantProvider'
import { TelephonySipProvider } from './contexts/SipExtensionContext'
import { AppSentryErrorBoundary, initializeSentry } from './observability/sentry'
import './index.css'

// Initialize i18n
import './i18n'

initializeSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppSentryErrorBoundary>
        <CallDetailDrawerProvider>
          <AuthProvider>
            <OperationalTabProvider>
              <OperatorLivePresenceProvider>
                <TelephonySipProvider>
                  <WebSocketProvider>
                    <ThemeModeProvider>
                      <PermissionProvider>
                        <TenantProvider>
                          <App />
                        </TenantProvider>
                      </PermissionProvider>
                    </ThemeModeProvider>
                  </WebSocketProvider>
                </TelephonySipProvider>
              </OperatorLivePresenceProvider>
            </OperationalTabProvider>
          </AuthProvider>
        </CallDetailDrawerProvider>
      </AppSentryErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
)
